<template>
    <div class="shop-bottom">
        <div class="shop-bottom-item click" :class="navValue == item.value?'active':''" v-for="item in navList" :key="item.value" @click="toState(item.url)">
            <span class="alifont" :class="item.icon"></span>
            {{item.name}}
        </div>
    </div>
</template>
<script>

    export default {
        name: 'shop-bottom',
        props:{
            shopId:{     //上传时额外参数
                type: String,
                default:''
            },
        },
        data() {
            return {
                navList:[
                    {name: '概况',icon:'icon-bianzu2',url:'equipmentHome',value: 0},
                    {name: '库存',icon:'icon-tixian',url:'equipmentStock',value: 1},
                    {name: '开门',icon:'icon-shezhibeifen',url:'equipmentOpenList',value: 2},
                    {name: '设置',icon:'icon-shezhi',url:'equipmentSetting',value: 3},
                ],
                navValue: this.$store.state.shop_nav_value
            }
        },
        created() {

        },
        mounted() {
        },
        methods: {
            toState(url){
                this.$router.replace({ name:url,query:{shopId:this.shopId}})
            }
        }
    }
</script>
<style lang="scss" scoped>
    .shop-bottom {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 70;
        width: 100%;
        height: 1.14rem;
        background: #fff;
        display: flex;
        padding: .2rem 0;
        align-items: center;
        .shop-bottom-item {
            flex: 1;
            color: #ABB0C0;
            font-size: .28rem;
            line-height: .4rem;
            height: .72rem;
            display: flex;
            align-items: center;
            justify-content: center;
            .alifont {
                font-size: .6rem;
                color: #ABB0C0;
            }
            &.active{
                color: $main-color;
                .alifont{
                    color: $main-color;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// equipment-navs.vue?3e526e7a